export abstract class CacheService {
  abstract createCache(name: string, options?: any);
  abstract clearCache(name: string);
  abstract get(key: string, cache?: string);
  abstract remove(key: string, cache?: string);
  abstract put(key: string, value: any, cache?: string, cacheOptions?: any);
}



// WEBPACK FOOTER //
// ./src/app/core/services/cache.service.ts